import parseDate from '@/helpers/parseDate'

export default {
  props: {
    endTime: {
      type: [Date, String, Number],
    }
  },
  data() {
    return {
      timer: null,
      timeDiff: 0
    }
  },
  computed: {
    endTimeMS() {
      return +(parseDate(this.endTime))
    },
    days() {
      const totalM = this.timeDiff / 1000 / 60
      return Math.floor(totalM / 60 / 24).toString().padStart(2, '0')
    },
    hours() {
      const totalM = this.timeDiff / 1000 / 60
      return Math.floor(totalM / 60 % 24).toString().padStart(2, '0')
    },
    minutes() {
      const totalM = this.timeDiff / 1000 / 60
      return Math.ceil(totalM % 60).toString().padStart(2, '0')
    }
  },
  methods: {
    createTimer() {
      clearInterval(this.timer)
      if(this.endTime === undefined) return

      this.setDif()
      this.timer = setInterval(() => {
        this.setDif()
      }, 1000)
    },
    setDif() {
      let currentTime = +(new Date())
      this.timeDiff = (new Date(this.endTimeMS) - currentTime) || 0

      if (this.timeDiff <= 0) {
        this.timeDiff = 0
        clearInterval(this.timer)
      }
    }
  },
  watch: {
    endTime() {
      this.createTimer()
    }
  },
  created() {
    this.createTimer()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
